export const TICKER_COMMS_INTERVAL = 2500;

const PREFIX = "ipl-swiggy-sixes-timer-crouton";
export const SWIGGY_SIXES_CROUTON_DATA_TEST_IDS = {
    CONTAINER: `${PREFIX}-container__{0}`,
    TEXT: `${PREFIX}-ticker-text`,
};
